export type OptionValue9 = string | number | boolean;

export class SelectOption9
{
    constructor (public value: OptionValue9, public label: string, public selected: boolean = false, public imgPath: string = '')
    {
    }
}
